import { useCallback } from 'react';

import { useTranslate } from '@dreryk/react-common';

import { practitionersTranslationKeys } from '../../../../../translations';

import { ConfidentialDataAccessOption } from './ConfidentialDataAccessCell.types';

export const useTriggerLabelExtractor = (): ((item: ConfidentialDataAccessOption) => string) => {
   const translate = useTranslate();

   return useCallback(
      (item: ConfidentialDataAccessOption): string =>
         translate(practitionersTranslationKeys.confidentialDataAccess[item]),
      [translate]
   );
};
